<template>
  <div class="properies-form">
    <v-card
      class="subtitle-1"
      v-if="
        product.properties[0] &&
        product.properties[0].propertyType &&
        !saveFlag &&
        properties &&
        properties.length > 0
      "
    >
      <v-card-title>{{ breadCrumb }}</v-card-title>

      <v-card-text>
        <v-form ref="ProductForm" v-model="ProductValid">
          <v-row
            class="mt-1"
            v-if="product.properties && product.properties.length"
          >
            <v-col
              v-for="(item, i) in product.properties"
              :key="i"
              cols="12"
              :sm="item.propertyType == 'Number' ? 8 : 4"
              :md="item.propertyType == 'Number' ? 6 : 4"
            >
              <v-text-field
                dense
                v-if="item.propertyType == 'Text' && item.required"
                required
                :label="item.title"
                :rules="[(v) => !!v || item.requiredText]"
                v-model="item.value"
                outlined
                class="mt-1"
              ></v-text-field>
              <v-text-field
                class="mt-1"
                :label="item.title"
                dense
                v-if="item.propertyType == 'Text' && !item.required"
                v-model="item.value"
                outlined
              ></v-text-field>
              <v-row v-if="item.propertyType == 'Number'">
                <v-col cols="12" :md="item.setMaxValue ? '3' : '5'" sm="6">
                  <v-text-field
                    :label="item.title"
                    dense
                    v-if="item.propertyType == 'Number' && item.required"
                    required
                    :rules="[
                      (v) => {
                        if (v == undefined) return true;
                        return (
                          /^[0-9]*[.][0-9]*$/.test(v) ||
                          /^[0-9]*$/.test(v) ||
                          'لطفا فقط عدد وارد کنید'
                        );
                      },
                    ]"
                    v-model="item.value"
                    outlined
                    class="mt-2"
                  ></v-text-field>
                  <v-text-field
                    :label="item.title"
                    :rules="[
                      (v) => {
                        if (v == undefined) return true;
                        return (
                          /^[0-9]*[.][0-9]*$/.test(v) ||
                          /^[0-9]*$/.test(v) ||
                          'لطفا فقط عدد وارد کنید'
                        );
                      },
                    ]"
                    dense
                    v-if="item.propertyType == 'Number' && !item.required"
                    v-model.number="item.value"
                    outlined
                    class="mt-2"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3" sm="6" v-if="item.setMaxValue">
                  <v-text-field
                    :label="'حد بالا ' + item.title"
                    dense
                    :rules="[
                      (v) => {
                        if (v == undefined) return true;
                        return (
                          /^[0-9]*[.][0-9]*$/.test(v) ||
                          /^[0-9]*$/.test(v) ||
                          'لطفا فقط عدد وارد کنید'
                        );
                      },
                    ]"
                    v-model="item.maxValue"
                    outlined
                    class="mt-2"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" :md="item.setMaxValue ? '3' : '4'" sm="6">
                  <v-select
                    dense
                    v-if="
                      item.propertyType == 'Number' &&
                      item.measurementUnitItem.length
                    "
                    :items="item.measurementUnitItem"
                    v-model="item.measurementUnitId"
                    :label="
                      'واحد اندازه گیری ' + item.measurementQuantityDisplayText
                    "
                    item-text="displayText"
                    item-value="id"
                    class="mt-2"
                    outlined
                  ></v-select>
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                  sm="6"
                  v-if="
                    categoryType == 'Product' ||
                    categoryType == 'IndustrialService'
                  "
                >
                  <v-checkbox v-model="item.setMaxValue" label="تعریف حد بالا">
                  </v-checkbox>
                </v-col>
              </v-row>
              <v-select
                :label="item.title"
                dense
                v-if="item.propertyType == 'SelectList' && item.required"
                required
                :rules="[(v) => !!v || item.requiredText]"
                :items="item.listValues"
                v-model="item.value"
                item-text="title"
                item-value="title"
                class="mt-1"
                clearable
                outlined
              ></v-select>
              <v-select
                :label="item.title"
                dense
                v-if="item.propertyType == 'SelectList' && !item.required"
                :items="item.listValues"
                v-model="item.value"
                item-text="title"
                item-value="title"
                class="mt-1"
                clearable
                outlined
              ></v-select>
              <v-select
                :label="item.title"
                dense
                v-if="item.propertyType == 'MultiSelectList' && item.required"
                required
                :rules="[(v) => !!v || item.requiredText]"
                :items="item.listValues"
                v-model="item.value"
                item-text="title"
                item-value="title"
                class="mt-2"
                clearable
                multiple
                outlined
              ></v-select>
              <v-select
                :label="item.title"
                dense
                v-if="item.propertyType == 'MultiSelectList' && !item.required"
                :items="item.listValues"
                v-model="item.value"
                item-text="title"
                item-value="title"
                class="mt-2"
                clearable
                multiple
                outlined
              ></v-select>
              <v-checkbox
                v-if="item.propertyType == 'Logical'"
                v-model="item.value"
                :label="item.title"
                small
                dense
              ></v-checkbox>
              <v-text-field
                :label="item.title"
                v-if="item.propertyType == 'Date' && item.required"
                :id="'DPicker' + i"
                dense
                outlined
                class="mt-1"
                v-model="item.value"
                clearable
                readonly
                required
                :rules="[(v) => !!v || item.requiredText]"
                prepend-inner-icon="mdi-calendar-range"
              ></v-text-field>
              <v-text-field
                :label="item.title"
                v-if="item.propertyType == 'Date' && !item.required"
                :id="'DPicker' + i"
                dense
                outlined
                class="mt-1"
                v-model="item.value"
                clearable
                readonly
                prepend-inner-icon="mdi-calendar-range"
              ></v-text-field>
              <date-picker
                :label="item.title"
                v-model="item.value"
                :element="'DPicker' + i"
                v-if="item.propertyType == 'Date'"
                class="mt-1"
              >
              </date-picker>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer> </v-spacer>
        <v-btn @click="nextStep()" color="primary"> ثبت</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
export default {
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  props: {
    breadCrumb: {
      type: String,
    },
    properties: {
      default: [],
      type: Array,
    },
    isSelectedProduct: {
      default: false,
      type: Boolean,
    },
    categoryType: {
      type: String,
      default: null,
    },
    measurementFlag: {
      default: false,
      type: Boolean,
    },
    selectedForEdit: {
      type: Array,
    },
  },
  data() {
    return {
      saveFlag: false,

      onceFalg: false,
      product: {
        properties: [],
        // propertySuggestions: [],
      },
      ProductValid: true,
      // propertySuggestions: false,
      propertySuggestionValid: true,
    };
  },
  created() {
    if (this.properties && this.properties.length > 0) {
      this.product.properties = this.properties;
      if (
        this.$store.getters.tradeRequestEditMode &&
        this.properties.length &&
        this.product.properties.length == this.selectedForEdit.length &&
        this.onceFalg == false &&
        this.measurementFlag
      ) {
        this.selectedForEdit.forEach((item, i) => {
          this.product.properties[i].value = this.selectedForEdit[i].value;
          this.product.properties[i].measurementUnitId =
            this.selectedForEdit[i].measurementUnitId;
          this.onceFalg = true;
        });
      }
    }
  },
  mounted() {},
  watch: {
    properties(after, before) {
      if (after && after.length > 0) {
        this.product.properties = after;
        if (
          this.$store.getters.tradeRequestEditMode &&
          after.length &&
          this.product.properties.length == this.selectedForEdit.length &&
          this.onceFalg == false &&
          this.measurementFlag
        ) {
          this.selectedForEdit.forEach((item, i) => {
            this.product.properties[i].value = this.selectedForEdit[i].value;
            this.product.properties[i].measurementUnitId =
              this.selectedForEdit[i].measurementUnitId;
            this.onceFalg = true;
          });
        }
      }
    },
    selectedForEdit(after, before) {
      if (this.$store.getters.tradeRequestEditMode && after.length) {
        this.selectedForEdit.forEach((item, i) => {
          this.properties[i].value = this.selectedForEdit[i].value;
          this.properties[i].measurementUnitId =
            this.selectedForEdit[i].measurementUnitId;
          this.properties[i].propertyId = this.selectedForEdit[i].propertyId;
        });
      }
    },
  },
  methods: {
    nextStep() {
      if (this.$refs.ProductForm.validate()) {
        this.nextStepActions();
      } else {
        this.$dialog.error({
          text: 'وارد کردن موارد ستاره دار الزامی میباشد',
          title: 'خطا',
          persistent: true,
          actions: [
            {
              text: 'بستن',
              color: 'red',
            },
          ],
        });
      }
    },
    nextStepActions() {
      // if (
      //   this.$refs.ProductForm.validate()
      // ) {
      const loader = this.$loading.show();
      const productProperties = [];
      if (this.product.properties.length > 0) {
        this.product.properties.forEach((element) => {
          let stringValue = null;
          if (element.propertyType == 'MultiSelectList') {
            if (element.value && element.value.length > 0) {
              element.value.forEach((val, index) => {
                stringValue = stringValue + val;
                if (index < element.value.length - 1) {
                  stringValue = stringValue + '|';
                }
              });
            }
          }
          let propertiesObject = {
            categoryPropertyId: element.propertyId,
            value:
              element.propertyType == 'MultiSelectList'
                ? stringValue
                : element.value,
            measurementUnitId:
              element.propertyType == 'Number'
                ? element.measurementUnitId
                : null,
          };
          if (element.propertyType == 'Number' && element.setMaxValue) {
            propertiesObject.maxValue = element.maxValue;
          }
          // if (this.$store.getters.tradeRequestIsEdit) {
          // propertiesObject.id = element.id ? element.id : null;
          propertiesObject.id = element.id ? element.id : null;
          // }
          productProperties.push(propertiesObject);
          // if (
          //   !this.$store.getters.tradeRequestIsEdit &&
          //   element.value &&
          //   !this.isSelectedProduct
          // ) {
          //   productProperties.push(propertiesObject);
          // } else if (!this.$store.getters.tradeRequestIsEdit && element.value) {
          //   productProperties.push(propertiesObject);
          // } else if (this.$store.getters.tradeRequestIsEdit && element.value) {
          //   productProperties.push(propertiesObject);
          // }
        });
      }
      this.$emit('completeProductProperties', {
        properties: productProperties,
        // propertySuggestions: this.product.propertySuggestions,
      });
      this.saveFlag = true;

      loader.hide();
    },
  },
};
</script>

<style scoped lang="scss">
.properies-form-font {
  font-family: Iran Sans, yekan-regular !important;
}
.v-label {
  font-family: Iran Sans, yekan-regular !important;
}
</style>
